import { FieldModel, ProgramBenchmarkName, ProgramTask, TaskDataTraitStatus } from '@cibo/core'
import { AmendmentCellDisplay } from '@cibo/landmanager'
import { TraitCellContainer } from './TraitCellContainer'

interface AmendmentCellProps {
  value: any
  task: ProgramTask<{ benchmarkName: ProgramBenchmarkName; traits: TaskDataTraitStatus[] }>
  year: number
  selectedField?: FieldModel
  onSaveSuccess?: () => void
}

export const AmendmentCell = ({
  value,
  task,
  year,
  selectedField,
  onSaveSuccess,
}: AmendmentCellProps) => {
  return (
    <TraitCellContainer
      value={value}
      task={task}
      selectedField={selectedField}
      year={year}
      traitId="amendment"
      onSaveSuccess={onSaveSuccess}
    >
      <AmendmentCellDisplay value={value} />
    </TraitCellContainer>
  )
}
